import * as React from 'react';
import { useTopNavigation } from '../../../queries/top-navigation';
import { useSitefinityFooter } from '../../../queries/sitefinity-footer';
import * as styles from './footer.module.scss';
import { classNames } from '../../../utilities/class-names';

export const Footer = () => {
    const topNav = useTopNavigation();
    const footer = useSitefinityFooter();

    return <>
        <div className={classNames(styles.footer, "e2e-footer-1")}>
            <div className={styles.footerContainer}>
                {footer.map(section => <React.Fragment key={section.title}>
                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>{section.title}</div>
                        {section.items.map(item => {
                            const Tag = item.url ? 'a' : 'div';
                            return <React.Fragment key={item.title}>
                                <div>
                                    <Tag className={classNames(styles.item, styles[item.type])} href={item.url} target={item.url ? '_blank' : null}>
                                        {item.title}
                                    </Tag>
                                </div>
                            </React.Fragment>
                        })}
                    </div>
                </React.Fragment>)}
            </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: topNav?.footerMarkup }} />
    </>
}

export default Footer;